import { withStyles } from '@material-ui/core';
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import XAPPComponent from 'app/Core/Components/XAPPComponent/XAPPComponent';
import clsx from 'clsx';
import dayjs from "dayjs";
import JoditEditor from "jodit-react";
import _ from 'lodash';
import MobileDetect from 'mobile-detect';
import React from 'react';

const md = new MobileDetect(window.navigator.userAgent);


const styles = theme => ({
    addButton: {
        position: 'absolute',
        right: 20,
        bottom: 60,
        zIndex: 99,
        color: theme.palette.text.primary,
    },
    toolbarItem: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: "4px 4px 0 0"
    }
});

class Conteudos extends XAPPComponent {

    state = {
        "updated": 1,
        "conteudos": {
            [dayjs(new Date()).format('YYYYMMDDHHmmssSSS')]: ""
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const form = this.state;
        if (!_.isNull(form.conteudos) && Object.keys(form.conteudos).length > 0 && !_.isEqual(form.conteudos, prevState.conteudos)) {
            let AArray = [];
            Object.keys(form.conteudos).forEach(key => {
                AArray.push({ "idmensagemconteudo": key, "conteudo": form.conteudos[key] });
            });
            this.props.handleChange({ "target": { "name": "conteudos", "value": AArray } });
        }
    }

    handleChangeCount = (_AKey = "new") => {
        let AConteudos = Object.assign({}, this.state.conteudos);

        if (_AKey === "new") {
            AConteudos[dayjs(new Date()).format('YYYYMMDDHHmmssSSS')] = "";
        }
        else {
            AConteudos[_AKey] = undefined;
        }

        this.setState({
            ...this.state,
            "updated": 0,
            "conteudos": AConteudos
        });
    };

    handleChangeConteudo = (_AKey, _AValue) => {
        let AConteudos = Object.assign({}, this.state.conteudos);
        AConteudos[_AKey] = _AValue;
        this.setState(_.set({ ...this.state }, "conteudos", AConteudos));
    }

    render() {
        const { theme, classes } = this.props;
        const form = this.state;

        return (
            <React.Fragment>
                <XAPPButton
                    tooltip={{ "title": "Adicionar", "placement": "top" }}
                    type="Fab"
                    color="primary"
                    className={classes.addButton}
                    onClick={() => this.handleChangeCount()}
                    icon={"add"}
                    iconProps={"text-24 text-white"}
                />
                <div className="overflow-y-auto h-360">
                    <div>
                        {Object.keys(form.conteudos).map(key => (
                            <React.Fragment>
                                <div className={clsx(classes.toolbarItem, "flex w-full flex-row h-36 mt-6")}>
                                    <div className="flex-1" />
                                    <XAPPButton
                                        tooltip={{ "title": "Remover", "placement": "top" }}
                                        type="Icon"
                                        className={"p-6 text-white"}
                                        onClick={() => { }}
                                        icon={"delete"}
                                    />
                                </div>
                                <JoditEditor
                                    className="h-640"
                                    value={form.conteudo}
                                    config={{
                                        //readOnly: readOnly,
                                        iframe: true,
                                        language: "pt_br",
                                        allowResizeX: false,
                                        allowResizeY: true,
                                        width: '100%',
                                        theme: theme.palette.type === "dark" && "dark",
                                        autofocus: false,
                                        showCharsCounter: false,
                                        showWordsCounter: false,
                                        showXPathInStatusbar: false,
                                        defaultActionOnPaste: "insert_only_text",
                                        uploader: {
                                            insertImageAsBase64URI: true
                                        }
                                    }}
                                    onBlur={value => this.handleChangeConteudo(key, value)}
                                />
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}


export default withStyles(styles, { withTheme: true })(Conteudos);
